import { render, staticRenderFns } from "./ViewImport.vue?vue&type=template&id=19412e61&scoped=true&"
import script from "./ViewImport.vue?vue&type=script&lang=js&"
export * from "./ViewImport.vue?vue&type=script&lang=js&"
import style0 from "./ViewImport.vue?vue&type=style&index=0&id=19412e61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19412e61",
  null
  
)

export default component.exports